import { AlertTriangle } from 'lucide-react'

import type { PreviewLine } from '@/features/pools/previewText'
import { cn } from '@/lib/cn'
import styles from './PreviewLines.module.scss'

/** As linhas numeradas de uma prévia de pool (ligar ou apagar). */
export function PreviewLines({ lines }: { lines: readonly PreviewLine[] }) {
  return (
    <ul className={styles.lines}>
      {lines.map((line) =>
        line.tone === 'danger' ? (
          <li key={line.text} className={cn(styles.line, styles.danger)}>
            <AlertTriangle aria-hidden />
            <span>
              {line.count !== null ? <strong>{line.count} </strong> : null}
              {line.text}
            </span>
          </li>
        ) : (
          <li key={line.text} className={styles.line}>
            <span className={cn(styles.count, line.tone === 'reserve' && styles.reserve)}>
              {line.count !== null ? line.count : '—'}
            </span>
            <span>{line.text}</span>
          </li>
        ),
      )}
    </ul>
  )
}
